import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import PortModel from '../../PortSelector/models/PortModel';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface portInputState {
    input: PortModel,
    selectedIndex: number,
    selectedUserId: number,
    triggerRefreshInput: number,
    inputExpand: boolean,
    triggerRefreshTable: number,
    ports: PortModel[],
    areas: string[],
    searchText: string,
    orderBy: string,
    orderDirection: OrderDirection
}

const initialState: portInputState = {
    input: {
        id: -1,
        name: "",
        area: "",
        masterArea: "",
    } as PortModel,
    selectedIndex: -1,
    selectedUserId: -1,
    triggerRefreshInput: 0,
    inputExpand: true,
    triggerRefreshTable: 0,
    ports: [],
    areas: [],
    searchText: "",
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
}

export const PortManagementSlice = createSlice({
    name: "PortManagement",
    initialState,
    reducers: {
        resetPortInput: (state) => {
            state.input = initialState.input;
        },
        setPortInput: (state, action: PayloadAction<PortModel>) => {
            state.input = action.payload;
        },
        setName: (state, action: PayloadAction<string>) => {
            state.input.name = action.payload;
        },
        setAera: (state, action: PayloadAction<string>) => {
            state.input.area = action.payload;
        },
        setMasterArea: (state, action: PayloadAction<string>) => {
            state.input.masterArea = action.payload;
        },
        setSelectedPortIndex: (state, action: PayloadAction<number>) => {
            state.selectedIndex = action.payload;
        },
        setSelectedPortId: (state, action: PayloadAction<number>) => {
            state.selectedUserId = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setInputExpand: (state, action: PayloadAction<boolean>) => {
            state.inputExpand = action.payload;
        },
        setTriggerRefreshTable: (state, action: PayloadAction<number>) => {
            state.triggerRefreshTable = action.payload;
        },
        setPorts: (state, action: PayloadAction<PortModel[]>) => {
            state.ports = action.payload;
        },
        setAreas: (state, action: PayloadAction<string[]>) => {
            state.areas = action.payload;
        },
        setPortSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
    }
});

export const portManagerSelector = createSelector(
    (state: RootState) => state.portManagement,
    (data) => data
);

export const {
    resetPortInput,
    setPortInput,
    setName,
    setAera,
    setMasterArea,
    setSelectedPortIndex,
    setSelectedPortId,
    setInputExpand,
    setTriggerRefreshTable,
    setPorts,
    setAreas,
    setPortSearchText,
    setOrderBy,
    setOrderDirection
} = PortManagementSlice.actions;

export default PortManagementSlice.reducer;